/* eslint-disable linebreak-style */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
/* eslint-disable import/extensions */

import React from 'react';
import { Fade } from 'react-awesome-reveal';
import Button from '../elements/Button';

export default function Portfolio({ data }) {
  return (
    <section className="container mx-auto flex flex-col items-center mt-20">
      <Fade direction="right" triggerOnce>
        <h1 className="text-5xl text-theme-white text-center font-bold">Latest Insights</h1>
      </Fade>
      <Fade direction="left" triggerOnce>
        <p className="font-light text-lg text-white-400 text-center mb-12">
          Stay Ahead.
        </p>
      </Fade>

      <div className="grid grid-cols-2 sm:grid-cols-3 sm:gap-2 xl:gap-8 justify-items-center">
        {
          data.map((item) => (
            <Fade direction="up" triggerOnce bottom delay={500 * data.indexOf(item)} key={item.id}>
              <Button type="link" href={`/project/${item.id}`}>
                <div className="shadow-card group rounded-2xl shadow-xl w-auto m-3 transform transition duration-500">
                  <div className="relative">
                    <div className="absolute flex w-full h-full top-0 opacity-0 justify-center rounded-t-2xl rounded-b img-hover">
                      <button className="focus:outline-none">
                        <svg className="w-20 h-20 text-gray-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div className="py-4 text-left"> {/* Align text to the left */}
                    <h2 className="text-theme-white text-xl font-bold mb-0">{item.title}</h2> {/* Title: Bold and larger, no margin */}
                    <p className="font-normal text-white text-lg">{item.type}</p> {/* Type: Smaller and not bold, no margin */}
                    <p className="font-light text-white text-base mt-4">{item.description}</p> {/* Description: Two lines below */}
                  </div>
                </div>
              </Button>
            </Fade>
          ))
        }
      </div>

      <Fade bottom triggerOnce>
        <Button href="/project" type="link" className="flex flex-grow-0 w-36 h-12 sm:w-40 sm:h-14 lg:w-44 lg:h-16 xl:w-36 xl:h-12 items-center mt-14 rounded-full justify-center transition duration-300 hover:text-white">
          <p className="gradient-button-variant flex items-center px-18 py-4 text-white text-x1 rounded-lg">
            See More
          </p>
        </Button>
      </Fade>
    </section>
  );
}
